<template>
    <header class="home_pag white lighten-1">
      <v-container fluid>
        <AppCarousel />
        <v-row v-if="loading">
         <v-col
           :md="6"
           :sm="12"
           :cols="12"
           >
           <v-skeleton-loader
              class="mx-auto white"
              height="360"
              type="image,image"
            ></v-skeleton-loader>
           </v-col>
           <v-col
           :md="6"
           :sm="12"
           :cols="12"
           >
           <v-skeleton-loader
              class="mx-auto white"
              type="image,image"
              height="360"
            ></v-skeleton-loader>
           </v-col>
        </v-row>
       <v-row v-else>
           <v-col
           :md="6"
           :sm="12"
           :cols="12"
           >
            <v-carousel
             :cycle="true"
             :reverse="carouselReverse"
             :show-arrows-on-hover="true"
             hide-delimiter-background
             height="360"
             >
                <v-carousel-item
                 v-for="(carouselItem, index) in carouselItems" :key="index"
                 :src='carouselItem.src'
                 >
                        <div class="carousal-text">
                         <v-sheet
                        color="rgb(0, 0, 0,.3)"
                        height="100%"
                        style=""
                        >
                        <div class="white--text text-capitalize " style="font-size:22pt" v-text="carouselItem.text"></div>
                        </v-sheet>
                        </div>
                        
                </v-carousel-item>
            </v-carousel>
           </v-col>
           <v-col 
           :md="6"
           :sm="12"
           :cols="12"
           >
           <div class="order-now">
            <v-row
             class="fill-height"
             :justify="$vuetify.rtl ? '' : 'end'"
             align="center"
            >
              <v-btn
              class="mx-10"
              link
              to="/order"
              :absolute='true'
              dark
              color='red'
              >
               {{$t("home.orderNow")}}
              </v-btn>
            </v-row>
           </div>
           </v-col>
       </v-row>
      </v-container>
  </header>
</template>

<script>
import AppCarousel from '@/components/home/Carousel';

export default {
    name:'home_header',
    data() {
        return {
            loading:true,
            carouselReverse:false, //true for rtl arabic direction
            carouselItems:[
                {
                src:require('@/assets/delever2.png'),
                text:''
             },
             {
                src:require('@/assets/pexels-samfotograffo-3052362.jpg'),
                text:'super delicious food delivery'
             },
             {
                src:require('@/assets/pexels-chan-walrus-1059943.jpg'),
                text:'we are the best'
             }
            ]
        }
    },
     components: {
    AppCarousel
  },
  beforeMount(){
    this.loading=true;
  },
  mounted(){
    this.loading=false
  }
}
</script>

<style lang="scss" >
  .order-now{
      background-image: url('../../assets/backgrounds/home/image-from-rawpixel-id-2312450-jpeg.jpg');
      height: 360px;
      background-position:100% 100% !important;
      background-size: cover;
  }
  .carousal-text{
    position: absolute;
bottom: 48px;
width: 100%;
left: 0;
text-align: center;
  }
</style>